import React from "react";
import { Route, Switch } from "react-router-dom";
import LoadableChunks from "../../../components/Loadable";
import { PATH } from "../../../constants";
import AdminSettings from "../Patient/Account";

const AdminRoutes = () => (
  <Switch>
    <Route
      exact
      path={PATH.admin.dashboard}
      component={LoadableChunks.admin.AdminDashboard}
    />
    <Route
      exact
      path={PATH.admin.patient}
      component={LoadableChunks.admin.AdminPatients}
    />
    <Route
      exact
      path={PATH.admin.provider}
      component={LoadableChunks.admin.AdminProviders}
    />
    <Route
      exact
      path={PATH.admin.properties}
      component={LoadableChunks.admin.AdminProperties}
    />
    <Route
      exact
      path={`${PATH.admin.properties}/:id([^&]*)`}
      component={LoadableChunks.provider.Property}
    />
    <Route
      exact
      path={PATH.admin.prescription}
      component={LoadableChunks.admin.AdminPrescriptions}
    />
    <Route
      exact
      path={`${PATH.provider.properties}/:id([^&]*)`}
      component={LoadableChunks.provider.Property}
    />
    <Route
      exact
      path={PATH.provider.newProperty}
      component={LoadableChunks.provider.NewProperty}
    />
    <Route
      exact
      path={`${PATH.provider.editProperty}/:id([^&]*)`}
      component={LoadableChunks.provider.PropertyEditor}
    />
    <Route
      exact
      path={PATH.admin.connections}
      component={LoadableChunks.provider.Application}
    />
    <Route
      exact
      path={PATH.admin.propertyChat}
      component={LoadableChunks.provider.PropertyChat}
    />
    <Route
      exact
      path={PATH.admin.account}
      component={LoadableChunks.admin.ProviderProfile}
    />
    <Route exact path={PATH.admin.settings} component={AdminSettings} />
    <Route component={LoadableChunks.landing.PageNotFound} />
  </Switch>
);

export default AdminRoutes;
